export const apiUrl =
    process.env.REACT_APP_API_URL ?? "https://setos.noretest2.com/";
export const tokenKey = "@token_key";
export const accessTokenKey = "@access_token_key";
export const captchaSiteKey =
    process.env.REACT_APP_CAPTCHA_SITE_KEY ??
    "6LccfyYgAAAAAJUkNlK5YI0htwVmSfnkVblaAwKZ";
export const captchaSiteKey2 =
    process.env.REACT_APP_CAPTCHA_SITE_KEY ??
    "6LdDAMUhAAAAAC4Vsf6jUSmM8MV_PbFOVBdxOrV0";

export const logoNore = "https://i.imgur.com/pmiSFwv.png";
export const imgPlaceholder = "https://i.imgur.com/Wu662Ir.jpg";

export const PEMILIK_TOKO = 10;
export const PEGAWAI_TOKO = 20;

export const font = "'Open Sans', sans-serif";
export const defaultColor = "#45A779";

export const validRegions = [
    "A",
    "B",
    "D",
    "E",
    "F",
    "G",
    "H",
    "K",
    "L",
    "M",
    "N",
    "P",
    "R",
    "S",
    "T",
    "W",
    "Z",
    "AA",
    "AB",
    "AD",
    "AE",
    "AG",
    "BA",
    "BB",
    "BD",
    "BE",
    "BG",
    "BH",
    "BK",
    "BL",
    "BM",
    "BN",
    "BP",
    "BR",
    "CC",
    "CD",
    "CE",
    "CG",
    "DA",
    "DB",
    "DD",
    "DE",
    "DG",
    "DH",
    "DK",
    "DL",
    "DM",
    "DN",
    "DP",
    "DR",
    "DS",
    "DT",
    "EA",
    "EB",
    "ED",
    "EE",
    "EF",
    "EG",
    "EH",
    "EK",
    "EL",
    "EM",
    "EN",
    "EP",
    "ER",
    "ES",
    "ET",
    "KB",
    "KH",
    "KT",
    "KU",
    "PA",
    "PB",
    "PD",
    "PE",
    "PG",
    "PH",
    "PK",
    "PL",
    "PM",
    "PN",
    "PP",
    "PR",
    "PS",
    "PT",
];
